import {atom} from "recoil";
import {FilterDef} from "../../../constants/FinanceModels";

export const ID_FILTER_LEGAL_ENTITY = 'legalEntity';
export const ID_FILTER_DEALER = 'dealer';

export const STATE_REFUELLING_ACTIVE_FILTERS = atom<FilterDef[]>({
    key: 'refuelling-state-active-filters',
    default: []
});